import { render, staticRenderFns } from "./PrinterHistory.vue?vue&type=template&id=2d3a7107&"
import script from "./PrinterHistory.vue?vue&type=script&lang=js&"
export * from "./PrinterHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports